module.exports = __webpack_public_path__ + "img/colorful_playful.cd1a210b.jpg";